import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface CondicaoGrupo {
  id?: string;
  // Adicione os campos necessários conforme o modelo real
}

@Injectable({
  providedIn: 'root'
})
export class CondicaoGrupoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: CondicaoGrupo[] }>(`${this.path}`, params ? new HttpParams({ fromObject: params }) : this.params).pipe(
      map(response => response)
    );
  }

  show(id: string): Observable<any> {
    return this.apiService.get<{ object: CondicaoGrupo }>(`${this.path}/${id}`).pipe(
      map(response => response)
    );
  }

  store(condicaoGrupo: CondicaoGrupo): Observable<any> {
    return this.apiService
      .post<{ object: CondicaoGrupo }>(`${this.path}`, condicaoGrupo)
      .pipe(map(response => response));
  }

  storeRange(grupos: CondicaoGrupo[]): Observable<any> {
    return this.apiService
      .post<{ data: CondicaoGrupo[] }>(`${this.path}/range`, grupos)
      .pipe(map(response => response));
  }

  update(condicaoGrupo: CondicaoGrupo): Observable<any> {
    return this.apiService
      .put<{ object: CondicaoGrupo }>(`${this.path}`, condicaoGrupo)
      .pipe(map(response => response));
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/${id}`);
  }
}
